<template>
  <div class="order-incomes">
    <h3>订单收费明细 - 总计{{this.price}}元</h3>
    <table class="table table-sm" v-for="income of incomes">
      <thead>
        <th>费用<local-time :time="income.created_at * 1000"></local-time></th>
        <th>小计</th>
        <th>计算规则</th>
      </thead>
       <tbody>
          <tr v-for="detail in income.details">
            <td>{{getIncomeTypeDisplay(detail.type)}}</td>
            <td>{{detail.amount}}元</td>
            <td>{{detail.calculation}}</td>
          </tr>
       </tbody>
    </table>
  </div>
</template>

<script>
import LocalTime from '@/components/_small/LocalTime'
import OrderMixin from '@/mixins/order'

function reloadData () {
  this.$http.get(`/api/orders/${this.orderNo}/incomes`).then(response => {
    this.incomes = response.data.data
  })
}

export default {
  name: 'order-incomes',
  props: ['orderNo'],
  mixins: [OrderMixin],
  data () {
    return {
      incomes: []
    }
  },
  created () {
    this.reloadData()
  },
  computed: {
    price: function () {
      let amount = this.incomes.map(element => element.amount).reduce(function (a, b) { return a + b }, 0)
      return Math.round(amount * 100) / 100
    }
  },
  methods: {
    reloadData
  },
  components: {
    LocalTime
  }
}
</script>
